import Vue from "vue";
const vm = new Vue();

export const getListOrderCodForExcel = async ( search , totalPage ) => {
    return new Promise((resolve, reject) => {
        let ExcelTask = []
        let page = 1;
        for( let i = 0 ; i < totalPage; i++ ){
            ExcelTask.push( vm.$http
                .post(
                    vm.$API_URL + "/shop/order/cod",
                    {
                        ...search,
                        page: page++
                    },
                    {
                        headers: {
                            Token: localStorage.getItem("access_token"),
                        },
                    }
                )
            ) 
        }
        Promise.all(ExcelTask).then( (resData) => {
            let dataExcel = [];
            resData.forEach( data => {
                dataExcel.push(...data.data.data.orders)
            })  
            resolve(dataExcel)
        })
    })
}